import { QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1450. 見積タスク登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  name: string;
  description?: string;
  due_date?: string;
};

const createQuotationTask = (props: Props): Promise<QuotationTask> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks`,
    props
  );
};

export const useCreateQuotationTask = () => {
  return useMutation({
    mutationFn: createQuotationTask
  });
};